
<div id="signin-page">
  <div class="img-container">
    <img src="../../assets/AdobeStock_2.jpg" alt="chemicals lab" class="left-col-image">
   
  </div>

  <div class="right-col">
    <div class="header">
      <img src="../../assets/syensqo_logo.png" alt="chemicals lab" class="left-solvayandsyensqo-image">
      <h1>SDS</h1>
    </div>
  <h2>Sign in</h2>
  <p>Welcome back! Enter your details to sign in</p>
  <form [formGroup]='loginForm' (ngSubmit)='onSubmit(loginForm.value)'>
  <div class="form-group-username">
    <label class="user">User Name</label>
    <input type="text" name="username" formControlName='username' placeholder="User Name"required>
  </div>
  <div class="form-group">
    <label class="password">Password</label>
    <input type="password" name="password"  formControlName='password'placeholder="Enter your Password" required>
  </div>
    <input type="submit" value="Sign in">
  </form>
  <div class="div">
    <div class='contact-info' (click)="showDialog()" >
      <p-dialog header="Contact us" [(visible)]="visible" [modal]="true"  [style]="{ width: '50vw', height: '250px' }" [draggable]="false" [resizable]="false" (onHide)="hideDialog()"    [transitionOptions]="'0ms'"     >
        <p class="contact">
          If you have connection problems or credentials problems on this sachem.syensqo.com site, please contact your usual HSE contact at Syensqo who will redirect your request urgently to the IT support. This is the only way to make sure the requested change comes really from a physical person from CARECHEM or CHEMTREC. Thank you so much.
      </p>
    </p-dialog>
      <h5 class="contact-us">Contact us</h5>
      <i class="pi pi-phone help-icon"></i>
    </div>
  </div>
</div>
</div>
